import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { RevokeAllSessionsResponse, SessionsListResponse } from "@/api/types";
import { assertCurrentSession, sessionRevision } from "@/lib/session-request-scope";

export function useRevokeAllSessions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.delete("sessions").json<RevokeAllSessionsResponse>(),
    onMutate: () =>
      queryClient
        .getQueryData<SessionsListResponse>(["sessions"])
        ?.sessions.filter((session) => !session.current)
        .map((session) => session.id),
    onSuccess: async (_data, _variables, knownSessionIds) => {
      const revision = sessionRevision();
      await queryClient.cancelQueries({ queryKey: ["sessions"], exact: true });
      assertCurrentSession(revision);
      queryClient.setQueryData<SessionsListResponse>(["sessions"], (data) =>
        data && knownSessionIds
          ? {
              ...data,
              sessions: data.sessions.filter((session) => !knownSessionIds.includes(session.id)),
            }
          : data,
      );
      void queryClient.invalidateQueries({ queryKey: ["sessions"], exact: true });
    },
  });
}
